module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- For ALL THAT APPLY QT when flag  Display As List For Visitor is set from portal. Displays option checkboxes horizontally.  -->\r\n<div id="apexchat_scripts_none_main_div_' +
((__t = (id)) == null ? '' : __t) +
'"\r\n    class="livechat_message_wrapper livechat_rd_fade_in_bottom apexchat_question_type_custom_style_div apexchat_question_type_confirm_or_skip apexchat_message';
 if(userId == -1){ ;
__p += ' apexchat_system';
};

 if(userId == 0){ ;
__p += ' apexchat_visitor';
};

 if(userId > 0 || userId == -3){ ;
__p += ' apexchat_agent';
};
__p += ' apexchat_script_message_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n    <div class="livechat_message_bubble_wrapper livechat_qt_bubble_wrapper livechat_ata_bubble_wrapper">\r\n        <div class="livechat_message_bubble">\r\n            <div class="apexchat_question_type_single_col prechat_bubble checkbox">\r\n                <div class="apexchat_question_type_confirm_or_skip"\r\n                    id="apexchat_question_type_div_close_button_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n                    <div title="Close" tabindex="0" id="apexchat-btn-skip-' +
((__t = (id)) == null ? '' : __t) +
'"\r\n                        class="apexchat_question_type_close_button apexchat_element_on_focus"></div>\r\n                </div>\r\n                <div class="apexchat_speaker apexchat_speaker_wrapper livechat_question_text">\r\n                    <div class="apexchat_text apexchat_participant_display_text" tabindex="0"\r\n                        id="apexchat_participant_display_text">\r\n                        ' +
((__t = (text )) == null ? '' : __t) +
'\r\n                    </div>\r\n                </div>\r\n                <div class="livechat_prechat_options_wrapper">\r\n                    <div id="apexchat_question_type_multiple_choice_file_div_' +
((__t = (id)) == null ? '' : __t) +
'" class="livechat_files_container">\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>';

}
return __p
}